import React from "react";
import { AppBar, Avatar, Box, Fab, Toolbar } from "@mui/material";
import theme from "../../theme";
import { Link } from "react-router-dom";
import { Apps, PersonOffOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "../../store";
import { toggleMenu } from "../../slices/shared";
import MenuView from "./Menu";
import Drawer from "../base/Drawer";
import Profile from "./Profile";

interface Props {}

const Navbar: React.FC<Props> = (props) => {
  const dispatch = useDispatch();

  const { menuOpen } = useSelector((store) => store.shared);
  const { dbUser } = useSelector((store) => store.auth);

  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar
        sx={{
          height: "65px",
          backgroundColor: theme.palette.background.paper,
          justifyContent: "space-between",
          paddingRight: 2,
        }}
        disableGutters
      >
        <Box
          display="flex"
          flexDirection={"row"}
          gap={4}
          alignContent="center"
          alignItems="center"
          height="100%"
          width="100%"
        >
          <Link style={{ height: "100%", objectFit: "cover" }} to={`/`}>
            <img
              height={"100%"}
              width={230}
              src={"/static/images/SVPro.png"}
              alt="logo"
              style={{
                objectFit: "cover",
              }}
            />
          </Link>
        </Box>
        <Box
          display="flex"
          flexDirection={"row"}
          gap={1}
          alignItems="center"
          justifyContent="flex-end"
          height="100%"
          width="100%"
        >
          <Box>
            <Fab
              color={menuOpen === "menu" ? "info" : "primary"}
              aria-label="menu"
              size="medium"
              onClick={() =>
                dispatch(toggleMenu(menuOpen !== "menu" ? "menu" : "none"))
              }
            >
              <Apps />
            </Fab>
          </Box>
          <Box>
            <Fab
              color={menuOpen === "profile" ? "info" : "primary"}
              aria-label="profile"
              size="medium"
              onClick={() =>
                dispatch(
                  toggleMenu(menuOpen !== "profile" ? "profile" : "none")
                )
              }
            >
              {!!dbUser ? (
                <Avatar
                  sx={{
                    backgroundColor: "transparent",
                    color: "#fff",
                    height: "50px",
                    width: "50px",
                    ":hover": { cursor: "pointer" },
                  }}
                >
                  {dbUser?.firstName[0] || ""}
                  {dbUser?.lastName[0] || ""}
                </Avatar>
              ) : (
                <PersonOffOutlined />
              )}
            </Fab>
          </Box>
        </Box>
        <Drawer
          open={menuOpen === "menu"}
          handleOpen={() => dispatch(toggleMenu("menu"))}
          handleClose={() => dispatch(toggleMenu("none"))}
          contents={
            <MenuView handleClose={() => dispatch(toggleMenu("none"))} />
          }
        />
        <Drawer
          open={menuOpen === "profile"}
          handleOpen={() => dispatch(toggleMenu("profile"))}
          handleClose={() => dispatch(toggleMenu("none"))}
          contents={
            <Profile handleClose={() => dispatch(toggleMenu("none"))} />
          }
        />
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
